// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"223":"commons","245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"223":"cfd373eb2981cabeff0b","245":"73cfc4b8c57b0a32d33d","453":"1a2c8324c6d3dbc92d28"}[chunkId] + ".js";
};